import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function MobileNav() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  const navItems = [
    { name: "Beranda", path: "/", icon: "🏠" },
    { name: "Produk", path: "/products", icon: "🛍️" },
    { name: "Keranjang", path: "/cart", icon: "🛒" },
    { name: "Pesanan", path: token ? "/orders" : "/login", icon: "📦" },
    ...(user?.role === "admin" 
      ? [{ name: "Admin", path: "/admin/dashboard", icon: "⚙️" }] 
      : []),
  ];

  return (
    <nav className="mobile-nav">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`mobile-nav-item ${isActive(item.path) ? "active" : ""}`}
        >
          <span className="mobile-nav-icon">{item.icon}</span>
          <span className="mobile-nav-label">{item.name}</span>
        </Link>
      ))}
    </nav>
  );
}
